import { render, staticRenderFns } from "./ListAprovacao.vue?vue&type=template&id=4d6768e9"
import script from "./ListAprovacao.vue?vue&type=script&lang=js"
export * from "./ListAprovacao.vue?vue&type=script&lang=js"
import style0 from "./ListAprovacao.vue?vue&type=style&index=0&id=4d6768e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports